<template>
    <v-container fluid>
        <Form
            v-if="lp"
            :model="lp"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.edit')"
        />
    </v-container>
</template>

<script>
import Form from './Form'
import LandingPage from '@/models/LandingPage'

export default {
    props: ['id'],

    components: {
        Form,
    },

    data: () => {
        return {
            lp: null,
        }
    },

    computed: {
        model() {
            return new LandingPage()
        },
    },

    methods: {
        async find() {
            this.lp = await this.model.find(this.id)
        },

        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.find()
    },
}
</script>

<style></style>
